<template>
  <b-card>
    <div class="row-flex">
      <div>
        <label class="mr-3">{{$t('actionTitle')}}:</label>
        <b-form-input
          class="input-pentagro"
          name="action"
          id="action"
          v-model="action.action"
          v-validate="{
            required: true,
          }"
          :state="validateState('action')"
          aria-describedby="action-feedback"
          :data-vv-as="$t('action')"
          :placeholder="$t('placeholderDescriptionAction')"
        />
        <b-form-invalid-feedback id="action-feedback">{{
          veeErrors.first("action")
        }}</b-form-invalid-feedback>
      </div>

      <div>
        <label class="mt-3" for="date-picker">{{$t('terminusTitle')}}</label>
        <span class="date">
          <date-picker
            id="date"
            class="adjustDatePickers"
            ref="datePickerStart"
            name="date"
            v-model.lazy="date"
            :config="optionsDatePicker"
            autocomplete="off"
            v-validate="{
              required: true,
            }"
            :state="validateState('ociosidade')"
            aria-describedby="date-feedback"
            :data-vv-as="$t('completionForecast')"
            :placeholder="$t('placeholderValidDate')"
          ></date-picker>
          <i class="fa fa-calendar fa-lg ml-2" aria-hidden="true"></i>
        </span>
        <b-form-invalid-feedback id="date-feedback">{{
          veeErrors.first("date")
        }}</b-form-invalid-feedback>
      </div>
    
      <div class="responsible-list mt-3">
        <label for="responsible-select">{{$t('responsibleForActionTitle')}}</label>
        <select
          class="form-control"
          id="responsibleSelect"
          name="responsible-select"
          v-model="action.responsible"
          v-validate="{
            required: true,
          }"
          :state="validateState('responsible-select')"
          aria-describedby="responsible-select-feedback"
          :data-vv-as="$t('responsibleForAction')"
        >
          <option value="-1" selected>{{$t('placeholderSelectAResponsible')}}</option>
          <template v-if="this.responsibles">
            <option
              v-for="responsible in this.responsibles"
              :key="`${responsible.id}-${responsible.unitId}-${responsible.system}`"
              :value="responsible"
              >{{ responsible.name }}</option
            >
          </template>
        </select>
        <b-form-invalid-feedback id="responsible-select-feedback">{{
          veeErrors.first("responsible-select")
        }}</b-form-invalid-feedback>
      </div>
    </div>
    <b-row class="groupBtn mt-4">
      <img
        src="@/assets/assinarEconfirmar.png"
        alt="Confirmar"
        style="margin-left: 20px"
        :title="$t('confirm')"
        @click="addingActionOccurence"
      />
      <img
        id="closeModalPassword"
        class="float-right"
        src="@/assets/sair.png"
        style="margin-right: 15px; margin-left: 20px"
        :title="$t('exit')"
        alt="Sair"
        @click="$bvModal.hide('addingAction')"
      />
    </b-row>
  </b-card>
</template>

<script>
import * as moment from "moment";
import "moment/locale/pt-br";
import { showError } from "@/global";
import { FiltersMixin } from "../mixins/filtersMixin";
import STATUS from "./statusEnum"

export default {
  name: "FormAction",

  props: ["result", "responsibles", "action", "baseDate"],

  mixins: [FiltersMixin],

  watch: {
    date(now) {
      let start = this.MaskDate(this.baseDate)
      let end = this.MaskDate(now);

      let dtStart = start.split("/")
      let dtEnd = end.split("/")
      let startDate = new Date(dtStart[2],dtStart[1]-1,dtStart[0])
      let endDate = new Date(dtEnd[2],dtEnd[1]-1,dtEnd[0])
      let diff = endDate.getTime() - startDate.getTime()

      this.action.date = end;
      if (diff < 0) {
        this.dateIsValid = false
      } else {
        this.dateIsValid = true
      }
    }
  },

  data: function() {
    return {
      date: new Date(),
      dateIsValid: true,
      otherDisabled: false,
      path: "",
      nodeSelected: "",
      optionsDatePicker: {
        locale: moment.locale("pt-br"),
        format: "DD/MM/YYYY",
        extraFormats: ["DD/MM/YYYY HH:mm:ss", "YYYY/MM/DD HH:mm:ss", "x"],
        dayViewHeaderFormat: "MMMM/YYYY",
        allowInputToggle: true,
        useCurrent: false,
        showTodayButton: true,
        showClear: true,
        showClose: true,
        sideBySide: false,
        inline: false,
        keepOpen: false,
        tooltips: {
          today: "Hoje",
          clear: "Limpar",
          close: "Fechar",
          selectMonth: "Selecionar mês",
          prevMonth: "Mês anterior",
          nextMonth: "Próximo mês",
          selectYear: "Selecionar ano",
          prevYear: "Ano anterior",
          nextYear: "Próximo ano",
          selectDecade: "Selecionar década",
          prevDecade: "Década anterior",
          nextDecade: "Próxima década",
          prevCentury: "Século anterior",
          nextCentury: "Próximo século",
        },
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    async addingActionOccurence() {
      // this.actions.push(action);
      let failValidator = false;
      await this.$validator.validateAll().then((result) => {
        if (!result) {
          showError(this.$t('campos-com-preenchimento-obrigatorio'));
          failValidator = true;
        }
      });

      let responsibleValid = this.action.responsible == -1;

      if (responsibleValid) showError(this.$t('selecione-um-responsavel-0'));

      if (failValidator || responsibleValid) return;

      if (!this.dateIsValid) {
        showError(this.$t('a-data-tem-que-ser-maior-que-a-data-de-producao') + this.MaskDate(this.baseDate));
        return;
      } 


      if(this.action.date.toString().includes("NAN"))
        this.action.date = this.MaskDate(new Date())  
      else
        this.action.date = this.MaskDate(this.action.date)

      if(!this.action.status)
        this.action.status = STATUS.PENDING;

      this.$emit("result", this.action);
      this.$bvModal.hide("addingAction");
    },
  },
  beforeMount() {
    if (this.actionEdit) {
      this.action = this.actionEdit;
    }
  },
  created() {
    this.$validator.localize("pt_BR");
    this.date = this.action.date
  },
};
</script>

<style scoped>
.date {
  display: flex;
}
</style>
